module.exports = __webpack_public_path__ + "img/line-number-01-02.a0e46358.svg";